import googleTagManager from '@analytics/google-tag-manager';
import { AnalyticsProvider as AnalyticsProvider_ } from '@inflearn/analytics';
import { Analytics as _Analytics } from 'analytics';
import type { ReactNode } from 'react';

export const analytics = _Analytics({
  app: 'inflearn-monolith',
  plugins: [
    googleTagManager({
      containerId: 'GTM-MVM7ZHX',
    }),
  ],
});

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  return <AnalyticsProvider_ analytics={analytics}>{children}</AnalyticsProvider_>;
}
